import { ButtonVariants } from '../../Atoms/Button';
import { TPricingPlans } from '../../S/pricing/types';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { startFilingLinkViewPlans } from '../../income-tax/static/data';
import { cardColor, pricingCard } from './pricing-card-util';

export type TCardData = {
  priceRange: string;
  planData: TPricingPlans[];
};
interface IPricingCard {
  cardData: TCardData;
}
export const PricingCard: React.FC<IPricingCard> = ({
  cardData,
}): JSX.Element => {
  return (
    <div>
      <div className="p-6 text-s-20 font-medium pb-6 border-b">
        Plan details
      </div>
      <div className="px-6 pb-6">
        <div className="flex gap-[14px] pb-12 sm:overflow-x-scroll">
          {cardData?.planData?.map((card, index) => {
            const planCard = pricingCard(cardData, card, index);
            const cardBadge = cardColor(planCard.cardBadgeText);

            return (
              <div
                key={index}
                className="mt-8 w-[198px] sm:flex-shrink-0"
                data-testid="pricing-card"
              >
                <div className="text-s-16 text-[#0E4EA2] pt-5 pb-7 px-4 bg-[#eff5ff] rounded-tl-lg rounded-tr-lg">
                  Taxable Income <br></br>
                  <span className="font-medium">
                    {planCard.cardTitle} Lakhs
                  </span>
                </div>
                <div className="relative bg-white z-10 top-[-10px] rounded-lg px-4 pt-0 border border-[#B7D5FE] h-[240px]">
                  <div className="pt-6 py-4 pb-4 border-b border-dotted h-[111px]">
                    <div className="h-[42px] text-s-14 text-grey-900 font-semibold">
                      {planCard.name}
                    </div>
                    <div
                      className="inline-block mt-2 rounded text-s-14 text-grey-900 px-3 font-semibold h-[21px]"
                      style={{
                        background: cardBadge,
                      }}
                    >
                      {planCard.isBadgeExist && (
                        <span>{planCard.cardBadgeText}</span>
                      )}
                    </div>
                  </div>

                  <div className="text-grey-900 text-s-24 font-semibold sm:text-base whitespace-nowrap">
                    ₹ {planCard.totalAmountInteger}
                  </div>
                  <div>
                    <span className="text-grey-700 text-base font-normal line-through sm:text-s-12 ">
                      ₹ {planCard.originalAmountInteger}
                    </span>
                  </div>
                  <div className="bg-[#0E4EA2] text-white rounded-sm px-2 mt-3 text-base font-semibold w-fit sm:text-s-10 whitespace-nowrap">
                    {planCard.planType}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <ButtonWithAnchor
          trackLabel="price_card_modal_button"
          buttonText=" Start Filing"
          buttonVariant={ButtonVariants.bluefilled}
          className="text-base px-12 w-full"
          buttonLink={startFilingLinkViewPlans}
        />
      </div>
    </div>
  );
};
